import { AlertTriangle, Loader2, RotateCw } from "lucide-react";
import { ASIGNAR } from "@/constants/testIds";

/** Pantalla mientras se confirma (o no se pudo confirmar) el estado con el servidor. */
export const VerificacionBoletos = ({ estado, onReintentar, onRegresar }) =>
  estado === "cargando" ? (
    <div
      data-testid={ASIGNAR.verificando}
      role="status"
      className="flex items-center gap-3 rounded-2xl border hairline bg-card p-8 text-sm text-muted-foreground"
    >
      <Loader2 className="w-5 h-5 animate-spin text-accent" strokeWidth={1.6} />
      Confirmando el estado de tus boletos…
    </div>
  ) : (
    <div
      data-testid={ASIGNAR.verificacionError}
      role="alert"
      className="flex flex-col items-start gap-4 rounded-2xl border hairline bg-card p-8"
    >
      <div className="flex items-center gap-2 text-destructive text-sm font-medium">
        <AlertTriangle className="w-5 h-5" strokeWidth={1.6} />
        No pudimos confirmar el estado de tus boletos.
      </div>
      <p className="text-sm text-muted-foreground max-w-md">
        Para evitar cambios sobre datos desactualizados, la edición se habilita cuando el servidor
        confirme el estado actual.
      </p>
      <div className="flex flex-wrap gap-3">
        <button
          type="button"
          data-testid={ASIGNAR.btnReintentarVerificacion}
          onClick={onReintentar}
          className="inline-flex items-center gap-2 rounded-full bg-primary px-5 py-2.5 text-sm text-primary-foreground hover:opacity-90 transition-opacity"
        >
          <RotateCw className="w-4 h-4" strokeWidth={1.6} /> Reintentar
        </button>
        <button
          type="button"
          data-testid={ASIGNAR.btnRegresarVerificacion}
          onClick={onRegresar}
          className="rounded-full border hairline px-5 py-2.5 text-sm text-foreground hover:bg-muted transition-colors"
        >
          Regresar
        </button>
      </div>
    </div>
  );

/** Boleto rechazado cuyo estado actual no se pudo confirmar: sin edición. */
export const BoletoPorConfirmar = ({ n, cargando, onReintentar }) => (
  <div
    data-testid={ASIGNAR.msgPorConfirmar(n)}
    role="alert"
    className="flex flex-col sm:flex-row sm:items-center gap-3 rounded-xl border border-amber-500/40 bg-amber-500/10 p-3 text-xs text-foreground"
  >
    <span className="flex-1">
      No pudimos actualizar el estado de este boleto. Tu cambio no se guardó y la edición queda
      bloqueada hasta confirmarlo.
    </span>
    <button
      type="button"
      data-testid={ASIGNAR.btnReintentarBoleto(n)}
      onClick={onReintentar}
      disabled={cargando}
      className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-xs font-medium border hairline bg-card text-foreground hover:bg-muted transition-colors disabled:opacity-50"
    >
      <RotateCw className={cargando ? "w-3.5 h-3.5 animate-spin" : "w-3.5 h-3.5"} strokeWidth={1.7} />
      Reintentar
    </button>
  </div>
);
